import type { MapProvider } from '@gpx-spa/geo-domain';
import {
  computed,
  inject,
  unref,
  type ComputedRef,
  type MaybeRef,
  type Ref,
} from 'vue';
import { GPX_MAP_PROVIDER_KEY } from '../map/gpx-map-injection-key.js';

/**
 * Resolves {@link MapProvider} from {@link GpxMap} (provide) or an explicit override (e.g. tests).
 */
export function useGpxMapProvider(override?: MaybeRef<MapProvider | undefined>): ComputedRef<MapProvider> {
  const injected = inject(GPX_MAP_PROVIDER_KEY, undefined);
  return computed(() => {
    const fromProp = override !== undefined ? unref(override) : undefined;
    if (fromProp) {
      return fromProp;
    }
    if (injected === undefined) {
      throw new Error('useGpxMapProvider: use inside GpxMap or pass mapProvider prop');
    }
    return unref(injected as MapProvider | Ref<MapProvider>);
  });
}
